import { render, staticRenderFns } from "./MiniEntity.vue?vue&type=template&id=0384167e&scoped=true&"
import script from "./MiniEntity.vue?vue&type=script&lang=js&"
export * from "./MiniEntity.vue?vue&type=script&lang=js&"
import style0 from "./MiniEntity.vue?vue&type=style&index=0&id=0384167e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0384167e",
  null
  
)

export default component.exports